var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInventoryListIcon = function SvgInventoryListIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 163,
    height: 163,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#A6B3BA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M74.354 40.558h67.596M74.354 81.116h67.596m-67.596 40.557h67.596M20.277 49.974s6.76 4.408 10.14 10.863c0 0 10.14-25.348 23.658-33.798M20.277 124.33s6.76 4.407 10.14 10.862c0 0 10.14-25.348 23.658-33.798"
  })));
};
export default SvgInventoryListIcon;